/* ------------------------ style ------------------------ */
import style from "./style.module.scss";

/* ------------------------ plugin ------------------------ */
import React, { useState, useEffect } from "react";

/* ------------------------ type ------------------------ */
import { type ResourceType, type ResourceOperateType, type PreviewResourcePropsType, ResourceTypeEnum } from './index-type';

/* ------------------------ components ------------------------ */
import PreviewVideo from "./components/PreviewVideo";
import PreviewImage from "./components/PreviewImage";

/* ------------------------ assets ------------------------ */
import PageLeft from "@/assets/icons/pageLeft.svg";
import PageRight from "@/assets/icons/pageRight.svg";
import CloseImage from "@/assets/icons/pageClose.svg";

const PreviewResource: React.FC<PreviewResourcePropsType> = ({
  open,
  resourceList = [],
  defaultUrl,
  trackExtraParams = {},
  bottomSlot,
  previewIndexChangeHandler,
  clickHandler,
  errorHandler,
  closeHandler,
}) => {
  const [openState, setOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [currentType, setCurrentType] = useState<ResourceType>(ResourceTypeEnum.Image);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setOpen(open);

    for (let i = 0; i < resourceList.length; i++) {
      let item = resourceList[i]
      if (item.url === defaultUrl) {
        setCurrentUrl(item.url);
        setCurrentType(item.type);
        setCurrentIndex(i);
        break;
      }
    }
  }, [open, defaultUrl]);

  useEffect(() => {
    previewIndexChangeHandler && previewIndexChangeHandler(currentIndex);
  }, [currentIndex]);

  const handleResourceOperate = (operateType: ResourceOperateType, resourceBaseInfo = {}) => {
    clickHandler && clickHandler(operateType, {
      index: currentIndex,
      type: currentType,
      url: currentUrl,
      ...resourceBaseInfo
    });
  }

  const handleResourceError = () => {
    errorHandler && errorHandler({
      index: currentIndex,
      type: currentType,
      url: currentUrl,
    });
  }

  const handlePageChange = (type: "left" | "right") => {
    if (type === "left" && currentIndex <= 0) return;
    if (type === "right" && currentIndex >= resourceList.length - 1) return;

    const newCurrentIndex = type === "left" ? currentIndex - 1 : currentIndex + 1;
    const newResourceInfo = resourceList[newCurrentIndex];
    setCurrentUrl(newResourceInfo?.url);
    setCurrentType(newResourceInfo?.type);
    setCurrentIndex(newCurrentIndex);
  };

  const handleClose = () => {
    closeHandler?.();
  }

  if (!openState || !currentUrl) return;

  return (
    <div className={style.preview_resource}>
      <div className={style.mask}>
        <div className={style.body}>
          {
            currentType === 'video' ?
              <PreviewVideo
                src={currentUrl}
                trackExtraParams={trackExtraParams.video || {}}
                resourceOperateHandler={(operateType, videoBaseInfo) => {
                  handleResourceOperate(operateType, videoBaseInfo);
                }}
                errorHandler={handleResourceError}
              /> :
              <PreviewImage
                src={currentUrl}
                trackExtraParams={trackExtraParams.image || {}}
                resourceOperateHandler={(operateType) => {
                  handleResourceOperate(operateType);
                }}
                errorHandler={handleResourceError}
              />
          }
        </div>

        {bottomSlot && bottomSlot(currentIndex)}
      </div>

      <div className={style.page_left} onClick={() => handlePageChange("left")}>
        <PageLeft />
      </div>

      <div className={style.page_right} onClick={() => handlePageChange("right")}>
        <PageRight />
      </div>

      <CloseImage className={style.close_icon} onClick={handleClose} />
    </div>
  );
};

export default PreviewResource;
